/** Mahesh (AFP-000005) Level 2 matrix: fixed payees by payment # (₹300 each). */
export const MAHESH_AUTO_FILL_PROGRAM_ID = "AFP-000005";

export const MAHESH_L2_SERIAL_FLOW_REF = "MAHESH_L2_SERIAL_FLOW";

/** @typedef {"WITHDRAWAL"|"UPGRADE"} MaheshL2Allocation */

/**
 * @type {Array<{
 *   paymentIndex: 1|2|3,
 *   programId: string,
 *   recipientLevel: number,
 *   allocation: MaheshL2Allocation,
 *   accountEmail: string,
 * }>}
 */
export const MAHESH_L2_SERIAL_PAYMENTS = [
  {
    paymentIndex: 1,
    programId: "AFP-000014",
    recipientLevel: 2,
    allocation: "WITHDRAWAL",
    accountEmail: "infinitywhale08@gmail.com",
  },
  {
    paymentIndex: 2,
    programId: "AFP-000015",
    recipientLevel: 1,
    allocation: "UPGRADE",
    accountEmail: "deeksha97.g@gmail.com",
  },
  {
    paymentIndex: 3,
    programId: "AFP-000016",
    recipientLevel: 2,
    allocation: "UPGRADE",
    accountEmail: "kalyani9466@gmail.com",
  },
];

export function maheshL2SerialRouteForPaymentIndex(paymentIndex) {
  return MAHESH_L2_SERIAL_PAYMENTS.find(
    (r) => r.paymentIndex === Number(paymentIndex)
  );
}

export function expectedMaheshL2FillerProgramId(paymentIndex) {
  return maheshL2SerialRouteForPaymentIndex(paymentIndex)?.programId ?? null;
}

export function isMaheshL2SerialFlow(uplineProgramId, level) {
  return (
    uplineProgramId === MAHESH_AUTO_FILL_PROGRAM_ID && Number(level) === 2
  );
}

/** Mahesh L1 + L2 matrix fillers in payment order (admin display when filledAt ties). */
export const MAHESH_MATRIX_SERIAL_FILLERS = [
  "AFP-000014",
  "AFP-000015",
  "AFP-000016",
];

export function maheshPayIndexForFillerProgramId(fillerProgramId) {
  const idx = MAHESH_MATRIX_SERIAL_FILLERS.indexOf(fillerProgramId);
  return idx >= 0 ? idx + 1 : null;
}
